import CrudManager from "@/components/admin/CrudManager";

export default function AdminEvents() {
  return (
    <CrudManager
      title="Events"
      subtitle="Beheer aankomende en voorbije events"
      listEndpoint="/events"
      adminEndpoint="/admin/events"
      fields={[
        { name: "title", label: "Titel", required: true },
        { name: "description", label: "Beschrijving", type: "textarea" },
        { name: "date", label: "Datum (leeg laten = Coming soon)", type: "date" },
        { name: "location", label: "Locatie" },
        { name: "image_url", label: "Afbeelding", type: "image" },
        { name: "register_url", label: "Inschrijflink (optioneel)" },
        { name: "type", label: "Type", type: "select", default: "upcoming", options: [{ value: "upcoming", label: "Aankomend" }, { value: "past", label: "Voorbij" }] },
      ]}
      columns={[
        { key: "title", label: "Titel" },
        { key: "date", label: "Datum", render: (it) => (it.date ? it.date : "Coming soon") },
        { key: "location", label: "Locatie" },
        { key: "type", label: "Type", render: (it) => (it.type === "upcoming" ? "Aankomend" : "Voorbij") },
      ]}
    />
  );
}
